import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'complaints-form',
  templateUrl: './complaints-form.component.html',
  styleUrls: ['./complaints-form.component.css']
})
export class ComplaintsFormComponent implements OnInit {
  title="View Complaint";
  data : any = {};
  formInvalid : boolean = false;
  c : any = {};
  ct:any={};
  a:any={};
  accused : any = {};

  Comp_id : number;
  mode : string;
  ComplaintTypelist:any = {}
 Complaintlist : any = {}
 AccusedDetails: any = [];
 hide : boolean = false;
 Officelist: any = {}
 show1 :boolean;
 show2 :boolean;
 numericpattern = "^[0-9]*$";
 alphabetpattern = "^[a-zA-Z ]*$";
 alphanumpattern = "^[a-zA-Z0-9 ]*$";
 emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$"; 
 agepattern="[1-100]";
 fileToUpload: File = null;  
  APP_PA_Age: any;
//  hide : boolean = false;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) 
  {     
    this.show1 = false;
    this.show2 = false;
  }
  showOne(){    
    this.show1 = true;
    this.show2 = false;
  }
  showTwo(){
    this.show1 = false;
    this.show2 = true;
  }

  ngOnInit() {



    this.route.params.subscribe(params => {      
      this.Comp_id = params['Comp_id'];  
      this.mode  =   params['mode'];   
        
        if(this.Comp_id > 0){
          this.GetByIdComplaint(this.Comp_id)
         
        } 
        this.GetAllData();   
    });

    if(this.mode=='View'){
      this.title = "View Complaint ";
      this.hide = true; 
    }
    else if(this.mode=='Edit'){
      this.title = "Edit Complaint";
    }  


    // //Get All complainttype
    // this.data = this.userService.GetAllComplaintType();
    // this.data.subscribe(
    // (response: any) => {
    //  this.ComplaintTypelist= response.Result; 
          
    // })
    
  }

  SaveComplaint(Complaint: NgForm){  
    debugger; 
    
    console.log('Save Form');
    console.log(Complaint.value);    
     
    if(Complaint.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                    
            Complaint.value.AccusedModel=this.AccusedDetails                 
            this.data = this.userService.PostComplaint(Complaint.value); 
            Complaint.value.Comp_DocPath = this.getFeasibilityComplaintFUrl();   
            this.data.subscribe(
            (response) => {
              Complaint.reset();
              Complaint.resetForm();
              Complaint.form.markAsPristine();
              Complaint.form.markAsUntouched();        
              swal('Success!', 'Complaint Added Successfully .', 'success');
              this.router.navigate(['/home/complaint/']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

 

  //upload
  imageUpload1(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            //  this.IS_UploadPath = event.target.result;
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData();
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImage3(data);
          x.subscribe(
            (response) => {
              
            }, (error) => {
              let i: any = document.getElementById('Comp_DocPath');
              i.value = "";
              if (error.status == 400) {
                //this.FeasibilityPDFUrl = "assets/images/image-default.png";
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('Comp_DocPath');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }
    
    
    
      getFeasibilityComplaintFUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('Comp_DocPath');
          return imagename.files[0].name;
        }
        catch (e) {
          return null;
        }
      }
  
//get by id

GetByIdComplaint(Comp_id){
  debugger

  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.userService.GetByIdComplaint(Comp_id);
  this.data.subscribe(
    (response: any) => {
      this.c = response;       

      if(response['Comp_From'] == 'P'){        
        this.show1 = true;
        this.show2 = false;
      }
     
      if (this.c.Comp_Recv_Date != null)
      this.c.Comp_Recv_Date = ((this.c.Comp_Recv_Date).split('T'))[0];
      // if (this.c.Case_Execution_Date != null)
      //   this.c.Case_Execution_Date = ((this.c.Case_Execution_Date).split('T'))[0];
      // if (this.c.Case_Reg_Date != null)
      //  this.c.Case_Reg_Date = ((this.c.Case_Reg_Date).split('T'))[0];        

      this.AccusedDetails = this.c.AccusedModel;
     // this.advDetails = this.c.AdvocatesOfCasesModels;
     // this.arbDetails = this.c.ArbitrationModels;        
      //this.GetCourtComplexandEstablishment(this.c.DistrictId)
  
     
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      if (error.status == 401|| error.status == 500) {
        this.errorHandler.handleError(error);
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    });
}
UpdateComplaint(Complaint: NgForm) {      
    
  //Duplicate check
  // var data = this.Complaintlist.filter(a => a.Case_No == this.c.Case_No && a.Case_Id != this.c.Case_Id);    
  // if(data.length > 0){    
  // swal('Warning!', 'Case No already exist.', 'warning');
  // return;      
  // }

  

  Complaint.value.AccusedModel = this.AccusedDetails;
  Complaint.value.Comp_DocPath = this.getFeasibilityComplaintFUrl();   
     
 // CaseReg.value.Case_UploadPath = this.getFeasibilityPDFUrl();
    

  this.data = this.userService.UpdateComplaint(Complaint.value,this.Comp_id);
      this.data.subscribe(
        (response) => {
          Complaint.reset();
          Complaint.resetForm();
          Complaint.form.markAsPristine();
          Complaint.form.markAsUntouched();
          
          this.AccusedDetails = [];         
          this.ComplaintTypelist=[];
          this.Officelist=[];
          
          swal('Success!', ' Complaint  updated Successfully .', 'success');
          document.getElementById('loader-spinner').style.display = "none";   
          this.router.navigate(['/home/complaint/']) ;         
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });    
}

Cancel(){

this.c.Comp_Num='';
this.c.Comp_Name='';
this.c.Comp_Gender='';
this.c.Comp_Nationality='';
this.c.Comp_Passport_no='';
this.c.Comp_Adhar_no='';
this.c.Comp_P_Name='';
this.c.Comp_Occuptn='';
this.c.Comp_Adress='';
this.c.Comp_mobile='';
this.c.Comp_Assgn_To='';
this.c.Comp_From='';
this.c.Comp_Mode='';
this.c.Comp_Recv_Date='';
this.c.Comp_Descptn='';
this.c.Comp_DOB='';
this.c.Comp_DocPath='';
this.c.Comp_CT_Id_Fk='';
}

GetAllData(){

 //Get All office
 this.data = this.userService.GetAllOffice1();
 this.data.subscribe(
 (response: any) => {
  this.Officelist= response.Result; 
 })
 //complaintytype
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.userService.GetAllComplaintType();
  this.data.subscribe(
    (response: any) => {
      this.ComplaintTypelist = response.Result;    
      //this.Officelist= response.result; 
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
    });
  }


//  delete row
 AccusedDetailsremove(i){ 
  swal({
    title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
  })     
  this.AccusedDetails.splice(i, 1);      
 }  
 // (error) => {
//   document.getElementById('loader-spinner').style.display = "none";
//   if (error.status == 401) {
//     this.errorHandler.handleError(error);
//   }
//   else if (error.status == 400) {
//     swal('Warning!', error.error.Message, 'warning');
//   }
// }





//
// AddAccusedDetails(a){  
//   debugger;  
//     let temp = {
//       Asd_Name : a.AccusedName,
//       Asd_Adress: a.AccusedAddress,
//       Asd_CT_id_Fk: a.cmplnt_id, 
//     }       


AddAccusedDetails(a){  
  
  console.log('Accused Details');
  console.log(a)
  //let bool = 0;     
  //if (a.AccusedName == "") { bool = 1 }
  if ((a.AccusedName != null || a.AccusedName != undefined)  && (a.AccusedAddress != null || a.AccusedAddress != undefined)  
 && (a.Asd_CT_id_Fk != null || a.Asd_CT_id_Fk != undefined)  ) {
  let temp = {
          Asd_Name : a.AccusedName,
          Asd_Adress: a.AccusedAddress,
          Asd_CT_id_Fk: a.Asd_CT_id_Fk, 
        }  

        this.AccusedDetails.push(temp);
    this.a = {};
      }
   
  else {
    swal('warning', 'Please enter mandatory fields!', 'warning');        
  }      
}   
  
  
  imageUpload(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.c.Comp_DocPath = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            //  this.IS_UploadPath = event.target.result;
          }
          reader.readAsDataURL(this.c.Comp_DocPath);
          const data = new FormData();
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImage(data);
          x.subscribe(
            (response) => {
              // console.log(response);
              // this.app.APP_PA_PhotoErrorMessage="";
    
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('Comp_DocPath');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }
    
    
    
      getFeasibilityPDFUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('Comp_DocPath');
          return imagename.files[0].name;
        }
        catch (e) {
          return null;
        }
      }

      CalculateAge(dateOfBirth) {
        this.data = this.userService.calculateAge(dateOfBirth);
        this.data.subscribe(
          (response: any) => {
            if (response <18){
              swal('Warning!', "Age cannot be less than 18 years to apply", 'warning');
              this.c.Comp_DOB=null;
            }
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }

      ClearAccused(){
        this.a = {};
      }
}




  






// WEBPACK FOOTER //
// ./src/app/Complaints/complaints-form/complaints-form.component.ts